import PageContainer from '@/common/components/PageContainer'
import DepositListing from '@/modules/transaction/components/DepositListing'
import { useTablePagination } from '@/common/hooks/useTablePaginate'
import useQueryDepositTransaction from '@/modules/transaction/api/hooks/useQueryDepositTransaction'
import { PermissionType } from '@/common/types'
import withUserPermission from '@/common/components/WithUserPermission'
import { PermissionKeys } from '@/modules/manage-member/mappers'
import { parseAsArrayOf, parseAsStringEnum, useQueryState } from 'nuqs'
import {
	TransactionProcessor,
	DepositStatus,
	SortOrder as OrderBy,
} from '@/schema'
import { useState } from 'react'
import { useDateFilter } from '@/common/hooks/useDateFilter'

type SortOrder = 'asc' | 'desc' | undefined

function DepositPage() {
	const { pageSize, currentPage, searchQuery } = useTablePagination()
	const [processBy] = useQueryState<TransactionProcessor>(
		'processBy',
		parseAsStringEnum(Object.values(TransactionProcessor)),
	)
	const [status] = useQueryState<DepositStatus[]>(
		'status',
		parseAsArrayOf(parseAsStringEnum(Object.values(DepositStatus))).withDefault(
			[],
		),
	)
	const [paymentGatewayId] = useQueryState('paymentGatewayId')

	const [amountSort, setAmountSort] = useState<SortOrder>(undefined)
	const [createdAtSort, setCreatedAtSort] = useState<SortOrder>('desc')
	const { dateFilter } = useDateFilter()

	const handleSort = (columnId: string, order: SortOrder) => {
		if (columnId === 'amount') {
			setAmountSort(order)
			setCreatedAtSort(undefined)
		} else if (columnId === 'createdAt') {
			setCreatedAtSort(order)
			setAmountSort(undefined)
		}
	}

	const payload = {
		take: pageSize,
		skip: (currentPage - 1) * pageSize,
		search: searchQuery,
		paymentGatewayId: paymentGatewayId || undefined,
		processor: processBy || undefined,
		status: status && status.length > 0 ? status : undefined,
		sortByCreatedAt: createdAtSort as OrderBy,
		sortByAmount: amountSort ? (amountSort as OrderBy) : undefined,
		startDate: dateFilter.startDate || undefined,
		endDate: dateFilter.endDate || undefined,
	}

	const { data, refetch, isLoading } = useQueryDepositTransaction(payload)

	const depositList = data?.data || []
	const totalDeposits = data?.total || 0

	return (
		<PageContainer>
			<div className="flex-1 space-y-4">
				<DepositListing
					data={depositList}
					total={totalDeposits}
					onRefresh={refetch}
					isLoading={isLoading}
					onSort={handleSort}
				/>
			</div>
		</PageContainer>
	)
}

const GuardedDepositPage = withUserPermission(DepositPage, {
	permissionType: PermissionType.Read,
	permissionKey: [PermissionKeys.MANAGE_BANK_TRANSACTION],
})

export default GuardedDepositPage
